import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import { messages } from "./messages";

const containerCss = css({
    padding: "0 60px"
});

const headerCss = css({
    fontFamily: token("font.family.brand.heading"), // Charlie Display
    fontWeight: 800,
    fontSize: "48px",
    lineHeight: "56px",
    textAlign: "center",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#000",
    marginBlockStart: "63px"
});

const subHeaderCss = css({
    fontFamily: token("font.family.brand.body"), // Charlie Text
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#000",
    margin: "8px 0 0 0"
});

export const PaidJiraAiHeader = () => {
    return (
        <div css={containerCss}>
            <h1 css={headerCss}>
                <FormattedMessage {...messages.getToDoneFaster} />
            </h1>
            <p css={subHeaderCss}>
                <FormattedMessage {...messages.aiPoweredProjectManagement} />
            </p>
        </div>
    );
};
